import { LayoutGrid, Table2 } from 'lucide-react';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';

export type ViewMode = 'card' | 'table';

interface Props {
  value: ViewMode;
  onChange: (v: ViewMode) => void;
  className?: string;
}

export default function ViewModeToggle({ value, onChange, className }: Props) {
  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={(v) => {
        if (v === 'card' || v === 'table') onChange(v);
      }}
      variant="outline"
      size="sm"
      className={`hidden md:inline-flex ${className ?? ''}`}
    >
      <ToggleGroupItem value="card" aria-label="Card view">
        <LayoutGrid className="h-4 w-4" />
      </ToggleGroupItem>
      <ToggleGroupItem value="table" aria-label="Table view">
        <Table2 className="h-4 w-4" />
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
